import React, { useEffect, useRef, useState } from 'react';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { useDispatch, useSelector } from 'react-redux';
import DeleteModal from '../common/DeleteModal';
import { isPermission, isRole } from '../../redux/selectors/authSelector';


const Performance = () => {
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuRefs = useRef([]);
    const [refresh, setRefresh] = useState(false);
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false)
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    const location = useLocation()
    console.log("permissions", permissions)
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
    const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;







    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
        // setOpenMenuIndex(true);
    };

    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.performance_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                setRefresh(!refresh);
            }
            else {

                dispatch(message(res.message));
            }
        });
        setLoader(false)
        setOpenMenuIndex(null);
    }

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.performance_list).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }else{
                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }
    useEffect(() => {
        fetchData();
    }, [refresh])


    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            menuRefs.current.forEach(ref => {
                if (ref && ref.contains(event.target)) {
                    clickedInside = true;
                }
            });
            if (!clickedInside) {
                setOpenMenuIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        // Navigate to /settings with currentTab only once
        if (location?.state?.currentTab !== "Performance") {
            navigate(`/education`, {
                replace: true,
                state: { currentTab: "Performance" },
            });
        }
    }, []);



    if (loader) {
        return <div>Loading....</div>
    }

    return (

        <>
            {data.length > 0 && data.map((item, index) =>
            (
                <div className="bg-white rounded-lg p-6 shadow-md relative text-gray-800   mx-auto">
                    <div>
                        <h2 className="text-2xl font-semibold mb-2">
                            {item.school_id.name} – Academic Performance Report
                        </h2>

                        <div className="text-sm mb-4">
                            <span className="mr-4">Performance Year: <span className="font-medium ">{item.year}</span></span>
                            <span className="mr-4">Total Number of Candidates: <span className="font-medium">{item.no_of_candidates}</span></span>
                            <span>Mean Grade: <span className="font-medium">{item.mean_grade}</span></span>
                        </div>

                        <div className="mb-4">
                            <h3 className="font-semibold mb-1 text-lg">Performance Summary</h3>
                            <p className="text-sm leading-relaxed">
                                {item.summary ? item.summary : "No summary available for this performance report."}
                            </p>
                        </div>

                        <div>
                            <h3 className="font-semibold mb-1 text-lg">Performance Narrative</h3>

                            <div dangerouslySetInnerHTML={{ __html: item.narrative }} />

                        </div>
                    </div>
                    {(addPermission || deletePermission) && <div className='bg-white '>
                        <div className="absolute top-3 right-3">
                            <button onClick={() => toggleMenu(index)}>
                                <img
                                    src={HiOutlineDotsVertical}
                                    className="text-black-500 hover:text-black"
                                />
                            </button>

                            {openMenuIndex == index && (
                                <div ref={(el) => (menuRefs.current[index] = el)} className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                                    {addPermission && <button
                                        className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                                        onClick={() => navigate(`/education/performance/edit/${item._id}`, { state: { type: "edit" } })}
                                    >
                                        Edit
                                    </button>}
                                    {deletePermission && <button
                                        onClick={() => {
                                            setSelectedId(item._id);
                                            setmodalOpenDelete(true);
                                        }}
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                    >
                                        Delete
                                    </button>}
                                </div>
                            )}
                        </div>

                    </div>}
                </div>
            )
            )}
            <DeleteModal
                title="Delete Performance"
                message="Are you sure you want to delete Performance?
It will erase all the data permanently."
                modalOpenDelete={modalOpenDelete}
                setmodalOpenDelete={setmodalOpenDelete}
                handleDelete={handleDelete} // Don't call it here
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                redirectPage={"Education"}
                redirectUrl={"/education"}
                module={"Performance"}
            />
              {
                    data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
                        <h1 className="text-center text-gray-400">No Data Found</h1>
                    </div>
                }
        </>

    );
};

export default Performance;
